const calculateDimensionVolume = (height, width, length) => {
  if (height === null || width === null || length === null) return 0;
  return (height * width * length) / 1000000000;
};

export default calculateDimensionVolume;
